import { FC } from 'react';

import { Combobox, Field, Fieldset } from '@/components';

import { CreateProjectFormData } from '../types';

interface ProjectDetailsFieldsProps {
  formData: CreateProjectFormData;
  errors: Partial<Record<keyof CreateProjectFormData, string>>;
  onFieldChange: (field: keyof CreateProjectFormData, value: unknown) => void;
  specificationOptions: Array<{ label: string; value: string }>;
  constructionTypeOptions: Array<{ label: string; value: string }>;
}

export const ProjectDetailsFields: FC<ProjectDetailsFieldsProps> = ({
  formData,
  errors,
  onFieldChange,
  specificationOptions,
  constructionTypeOptions,
}) => {
  return (
    <Fieldset legend="Project Details">
      <Field
        label="Construction Types"
        htmlFor="construction-types-select"
        error={errors.constructionTypes}
        required
      >
        <Combobox
          optionGroups={[
            {
              label: 'Construction Types',
              options: constructionTypeOptions.map((option) => ({
                label: option.label,
                value: option.value,
              })),
            },
          ]}
          value={formData.constructionTypes}
          onValueChange={(values) => {
            onFieldChange('constructionTypes', values);
          }}
          fallbackLabel={'no construction types found'}
          placeholder={'Select Construction Types'}
          fullWidth
        />
      </Field>

      <Field label="Specifications" htmlFor="specifications-select" error={errors.specifications}>
        <Combobox
          optionGroups={[
            {
              label: 'Specifications',
              options: specificationOptions.map((option) => ({
                label: option.label,
                value: option.value,
              })),
            },
          ]}
          value={formData.specifications}
          onValueChange={(values) => {
            onFieldChange('specifications', values);
          }}
          fallbackLabel={'no specifications found'}
          placeholder={'Select Specifications'}
          fullWidth
        />
      </Field>
    </Fieldset>
  );
};
